import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import {
  CalendarTicketsFilterModel,
  Environment,
  ITicketsDashModel,
  ITicketsXsModel,
  IonTicketListIdsModel,
  IsError,
  ModelBool,
  ModelGuid,
  ModelNum,
  ModelNumSearch,
  MyTicketIdsGroupByModel,
  MyTicketsGroupFilterModel,
  TicketIdsModel,
  TicketUltimoStatoXs,
  Tickets,
  TicketsPianificati,
  TicketsPianificatiSequenzaModel,
  Tickets_TableModel,
} from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class TicketsService extends CrudGenericsService<Tickets, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Tickets`);
    this.base = `${env.apiUrl}/api/Tickets/`;
  }

  // ======== web =========
  public GetTickets_TableModel(date_min: string, date_max: string): Observable<Tickets_TableModel[]> {
    const u = `${this.base}GetTickets_TableModel?date_min=${date_min}&date_max=${date_max}`;
    return this.http.get<Tickets_TableModel[]>(u);
  }

  public Get4SelectSingle(id: number): Observable<ModelNumSearch> {
    const u = `${this.base}Get4SelectSingle?id=${id}`;
    return this.http.get<ModelNumSearch>(u);
  }
  public MyTicketsCount(): Observable<ModelNum> {
    const u = `${this.base}MyTicketsCount`;
    return this.http.get<ModelNum>(u);
  }

  // web caledar
  public GetCalendarTicketsWeb(): Observable<CalendarTicketsFilterModel> {
    const u = `${this.base}GetCalendarTicketsWeb`;
    return this.http.get<CalendarTicketsFilterModel>(u);
  }

  // web my tickets
  public GetMyTiketsWeb_GroupByModel(): Observable<MyTicketsGroupFilterModel> {
    const u = `${this.base}GetMyTiketsWeb_GroupByModel`;
    return this.http.get<MyTicketsGroupFilterModel>(u);
  }

  public Dashboard_Sintesi(id: number, dtmin: string, dtmax: string, idtipo: string): Observable<ITicketsDashModel> {
    const u = `${this.base}Dashboard_Sintesi?id=${id}&date_min=${dtmin}&date_max=${dtmax}&idTipoTicket=${idtipo}`;

    return this.http.get<ITicketsDashModel>(u);
  }
  /*      this.base +
      'Dashboard_Sintesi?id=' +
      id +
      '&date_min=' +
      date_min +
      '&date_max=' +
      date_max +
      '&idTipoTicket=' +
      idTipoTicket; */
  // ======================

  // ..........ionic ...........

  // 1 ticket
  public GetSingle_TicketsXsModel(id: number): Observable<ITicketsXsModel> {
    const u = `${this.base}GetSingle_TicketsXsModel?id=${id}`;
    return this.http.get<ITicketsXsModel>(u);
  }
  // all tickets ionic
  public GetAll_TicketsXsModel(): Observable<ITicketsXsModel[]> {
    const u = `${this.base}GetAll_TicketsXsModel`;
    return this.http.get<ITicketsXsModel[]>(u);
  }

  // in home (non usata in ionic sostituita con quella sotto)
  public GetMyTikets_TicketIdsModel(): Observable<TicketIdsModel[]> {
    const u = `${this.base}GetMyTikets_TicketIdsModel`;
    return this.http.get<TicketIdsModel[]>(u);
  }
  // in home
  public GetMyTiketsIdsGroupModel(): Observable<MyTicketIdsGroupByModel> {
    const u = `${this.base}GetMyTiketsIdsGroupModel`;
    return this.http.get<MyTicketIdsGroupByModel>(u);
  }

  // nella lista dopo la scansione tab tickets, modello di post per richiedere
  public IonicGetList_TicketIdsModel(model: TicketIdsModel): Observable<IonTicketListIdsModel> {
    const u = `${this.base}IonicGetList_TicketIdsModel`;
    return this.http.post<IonTicketListIdsModel>(u, model);
  }
  // utility verifica se puo' chiudere il ticket
  public CanTicketAction_Chiude(id: number): Observable<ModelBool> {
    const u = `${this.base}CanTicketAction_Chiude?id=${id}`;

    return this.http.get<ModelBool>(u);
  }
  public GetUltimoStato(id: number): Observable<TicketUltimoStatoXs> {
    const u = `${this.base}GetUltimoStato?id=${id}`;
    return this.http.get<TicketUltimoStatoXs>(u);
  }
  public TicketHaSchede(id: number): Observable<ModelBool> {
    const u = `${this.base}TicketHaSchede?id=${id}`;
    return this.http.post<ModelBool>(u, null);
  }
  public TicketCambioData(id: number, minuti: number): Observable<IsError> {
    const u = `${this.base}TicketCambioData?id=${id}&minuti=${minuti}`;
    return this.http.post<any>(u, null);
  }
  // == inizio  tickets pianificati == //
  public TicketPianificati_CreateSequenza(model: TicketsPianificati): Observable<IsError> {
    const u = `${this.base}TicketPianificati_CreateSequenza`;

    return this.http.post<any>(u, model);
  }
  public TicketPianificati_GetSequenza(guid: string): Observable<TicketsPianificatiSequenzaModel> {
    const u = `${this.base}TicketPianificati_GetSequenza?guid=${guid}`;
    return this.http.get<TicketsPianificatiSequenzaModel>(u);
  }
  public TicketPianificati_RemoveSequenza(sequenza: string): Observable<any> | null {
    const guid: ModelGuid = { Value: sequenza };
    const u = `${this.base}TicketPianificati_RemoveSequenza`;
    return this.http.post<any>(u, guid);
  }

  // == fine   tickets pianificati == //
}
